import { axios } from "../../cores/axiosWrapper";

export function createSearchIndexAPI(stageId, apiEndpoint, projectId, data) {
    const headers = {};
    if (stageId) headers.stageId = stageId;
    if (projectId) headers.projectId = projectId;

    return axios.post(`${apiEndpoint}/v3/integrated-search/index`, data, { headers });
}

/**
 * 여러 리소스의 검색 인덱스를 한 번에 재생성 요청한다.
 * 접수형 비동기 API로 응답은 접수 개수({ accepted })이며, 건별 성패는 목록의 indexDoc.status로 추적한다.
 * @param {string} stageId
 * @param {string} apiEndpoint
 * @param {string} projectId
 * @param {{domain: "ASSET", resourceIds: string[]}} data - resourceIds는 요청당 1~100개
 */
export function bulkUpsertResourceIndexAPI(stageId, apiEndpoint, projectId, data) {
    const headers = {};
    if (stageId) headers.stageId = stageId;
    if (projectId) headers.projectId = projectId;

    return axios.post(`${apiEndpoint}/v3/integrated-search/indexes:bulk`, data, { headers });
}
